import { type FC } from "react";
import { useTranslation } from "react-i18next";
import {
  AudienceEditor,
  AudienceFilterBuilder,
} from "@/partner/features/audience";
import { Automations } from "@/partner/features/automations";
import { ContentsAutocomplete } from "@/partner/features/contents";
import {
  EmailTemplateAutocomplete,
  EmailTemplatePreviewById,
} from "@/partner/features/emailTemplates";
import {
  AUDIENCE_FIELDS,
  MarketingComponentsProvider,
  useMarketingLimits,
  type ConditionFilterBuilderProps,
  type ContentsPickerProps,
  type MarketingComponents,
} from "@/partner/entities/marketing";
import { ProductLabelsProvider } from "@/partner/entities/products";
import { Meta } from "@/shared/components";

/**
 * Фильтр шага условия цепочки: поля аудитории плюс поля условия из правил
 * сервера; без них (правило выхода) только поля аудитории.
 */
const ConditionFilterBuilderPiece: FC<ConditionFilterBuilderProps> = ({
  value,
  onChange,
  disabled,
  emailNodes,
  conditionFields,
}) => {
  const limits = useMarketingLimits();
  return (
    <AudienceFilterBuilder
      value={value}
      onChange={onChange}
      disabled={disabled}
      limits={limits}
      fields={
        conditionFields ? [...AUDIENCE_FIELDS, ...conditionFields] : undefined
      }
      emailNodes={emailNodes}
    />
  );
};

const ContentsPickerPiece: FC<ContentsPickerProps> = ({
  label,
  value,
  onChange,
  disabled,
  max,
}) => (
  <ContentsAutocomplete
    label={label}
    value={value}
    onChange={onChange}
    disabled={disabled}
    max={max}
  />
);

// Страница собирает куски других фич для редактора автоматизаций.
const MARKETING_COMPONENTS: MarketingComponents = {
  AudienceEditor,
  EmailTemplatePicker: EmailTemplateAutocomplete,
  EmailTemplatePreview: EmailTemplatePreviewById,
  ConditionFilterBuilder: ConditionFilterBuilderPiece,
  ContentsPicker: ContentsPickerPiece,
};

export function AutomationsPage() {
  const { t } = useTranslation();

  return (
    <MarketingComponentsProvider value={MARKETING_COMPONENTS}>
      <Meta title={t("automations.pageTitle")} pageType="Partner" />
      {/* Названия выбранных продуктов во всех условиях редактора одним
          запросом (супер-ревью кабинета 9). */}
      <ProductLabelsProvider>
        <Automations />
      </ProductLabelsProvider>
    </MarketingComponentsProvider>
  );
}
